// import 'bootstrap/js/dist/util.js';
import Tab from 'bootstrap/js/dist/tab.js';
import 'easyticker-jquery/jquery.easy-ticker.min';
import 'slick-carousel/slick/slick.min.js';

import { i18n } from './utils.js';

var Slider = function () {
  var $slider = $('#teaser');
  var videos = $slider.find('[id^="video"]');
  var player;
  var players = [];
  var _onPlayerReady;
  var _onPlayerStateChange;

  var _slickConfig = {
    autoplay: true,
    autoplaySpeed: 7500,
    dots: true,
    draggable: false,
    fade: true,
    speed: 1000,
    waitForAnimate: false
  };

  function initSlider () {
    $slider.slick(_slickConfig)

    if(videos.length > 0) {
      loadYouTubeIframeAPI()
    }
  }

  function loadYouTubeIframeAPI() {
    var tag = document.createElement('script')

    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  function setupPlayer() {
    for (var i = 0; i < videos.length; i++) {
      var id = videos[i].id.replace('video', '')
      var $wrapper = $(videos[i])
      var height = $wrapper.attr('height')
      var width = $wrapper.attr('width')
      var style = $wrapper.attr('style')

      player = new YT.Player('video'+id, {
        height: height,
        width: width,
        videoId: id,
        playerVars: {
        autoplay: 0,
        enablejsapi: 1,
        modestbranding: 1,
        origin: 'https://www.medi-king.de',
        rel: 0,
        showinfo: 0,
        html5: 1
        },
        events: {
          'onReady': function(e) {
            onPlayerReady(e)
          },
          'onStateChange': function(e) {
            onPlayerStateChange(e)
          }
        }
      })

      var $iframe = $('#video'+id)
      $iframe.attr('style', style)
    }
  }


  function onPlayerReady(e) {
    // console.log('Player ready')
    // console.log(e)
  }

  function onPlayerStateChange(e) {
    if (e.data === YT.PlayerState.PLAYING) {
      Slider.stop()
    } else if (e.data === YT.PlayerState.ENDED || e.data === YT.PlayerState.PAUSED) {
      Slider.resume()
    }
  }

  function startSlider () {
    $slider.slick('slickPlay')
  }

  function stopSlider () {
    $slider.slick('slickPause')
  }

  return {
    init : initSlider,
    resume : startSlider,
    stop : stopSlider,
    setupPlayer : setupPlayer
  }
}();

window.onYouTubeIframeAPIReady = () => {
  Slider.setupPlayer()
};

const carouselItemCount = 4;
let carouselCount = 0,
    carouselLoadError = 0;

const initCarouselSlider = (element, data) => {
  const $el = $(element),
        $data = $(data);

  // check if response has any product item html
  if($data.length > 0) {
    // inject product html
    $el.html(data);

    // init slick slider
    $el.slick({
      dots: false,
      infinite: false,
      slidesToShow: carouselItemCount,
      slidesToScroll: carouselItemCount,
      responsive: [{
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }, {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]
    });
  } else {
    const id = $el.parent().attr('id');

    if(id) {
      $(`[href="#${id}"]`).addClass('disabled');
    }

    loadCarouselDataError(element);
  }
}

const loadCarouselDataError = (element, response) => {
  carouselLoadError++;

  // remove spinner
  $(element).html(`<p class="text-center h2 py-3">${i18n('home.carousel.empty')}</p>`);

  if ( carouselLoadError === carouselCount ) {
    $('#product-carousel-tabs').fadeOut('slow');
  } else {
    const notActiveTab = document.querySelector('#product-carousel-tabs a:not(.active)');
    if (notActiveTab) new Tab(notActiveTab).show();
  }
};

const loadCarouselData = (carousel, index, count, callback) => {
  $.get({
    url: `${carousel.dataset.url}`,
    data: { first: index, last: index+count-1 },
    success: (data) => callback(carousel, data),
    error: (response) => loadCarouselDataError(carousel, response)
  });
};

const initCarouselTab = (containers) => {
  containers.html('<div class="spinner"></div>');

  containers.each((i, el) => {
    // load initial carousel data
    // set to 40 to load "all" data
    loadCarouselData(el, 1, carouselItemCount * 10, initCarouselSlider);
  });
}

(function($) {
  // Init Main Slider
  if($('#teaser li').length > 1) {
    Slider.init()
  }

  // Init Newsticker
  $('.newsticker').easyTicker({
    direction: 'up',
    easing: 'swing',
    speed: 'slow',
    interval: 7000,
    height: 'auto',
    visible: 1,
    mousePause: 1
  });

  const $carouselTabs = $('#product-carousel-tabs .nav-link');
  $carouselTabs.on('shown.bs.tab', (e) => {
    // slick slider can't initialize properly inside hidden elements (tabs here)
    // manually reset layout on showing tabs
    $(e.currentTarget.hash).find('.carousel.slick-initialized').slick('setPosition');
  });

  const $carouselTab = $('.carousel');
  // save the number of carousels we have
  // needed to remove tabs when no data can be loaded
  carouselCount = $carouselTab.length;
  if (!$carouselTab.hasClass('slick-initialized')) {
    initCarouselTab($carouselTab);
  }
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/home.js